import { Modelo } from '@ext/index';
import * as Types from './Diaria.types';
import * as Pedidos from '@lib/Ventas/Pedidos';
import moment, { Moment } from 'moment';

export class IEstadisticaDiaria extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Fecha: Moment;
    public Tipos: Pedidos.Tipos[] = [];
    public Facturacion: number = 0;
    public Pedidos: number = 0;
    public Items: number = 0;


    public set(): boolean
    {

        this.Fecha = moment( this.Json.fecha );
        this.Facturacion = this.Json.facturacion;
        this.Pedidos = this.Json.pedidos;
        this.Items = this.Json.pedidos;
        this.Tipos = String( this.Json.tipos ).split( ',' ).map( x => Pedidos.Tipos.toTipo( x ) );

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: ITitulo )
    {
        this.Model = Model;
    }

    public Model: ITitulo;
}